export default __webpack_public_path__ + "870d8d842a5936fa01c9dc6883959ce5.svg";